import type { LuminarySettings } from '@lumen5/luminary';

import { SourceEnum } from 'js/src/client';

// all media sources that users need to pay to access (unlimited use & credit)
export const PREMIUM_SOURCES = new Set([
    SourceEnum.SOURCE_GETTY,
    SourceEnum.SOURCE_GETTY_UNLIMITED,
    SourceEnum.SOURCE_SHUTTERSTOCK_ESSENTIALS,
    SourceEnum.SOURCE_SHUTTERSTOCK_PREMIUM,
    SourceEnum.SOURCE_SHUTTERSTOCK_UNLIMITED,
    SourceEnum.SOURCE_SHUTTERSTOCK_EDITORIAL,
    SourceEnum.SOURCE_SHUTTERSTOCK_CHOICES,
]);

export const RENDERING_BLOCKING_SOURCES = [
    SourceEnum.SOURCE_GETTY,
    SourceEnum.SOURCE_SHUTTERSTOCK_PREMIUM,
    SourceEnum.SOURCE_SHUTTERSTOCK_EDITORIAL,
];

export const DEFAULT_LUMINARY_CONFIG: LuminarySettings = {
    mediaSizeToUse: Luminary.VideoData.PREVIEW_MEDIA_SIZE,
};

export const ORDERED_TEXT_POSITIONS = [
    Luminary.VideoData.TOP_LEFT_TEXT_POSITION,
    Luminary.VideoData.TOP_CENTER_TEXT_POSITION,
    Luminary.VideoData.TOP_RIGHT_TEXT_POSITION,
    Luminary.VideoData.CENTER_LEFT_TEXT_POSITION,
    Luminary.VideoData.CENTER_TEXT_POSITION,
    Luminary.VideoData.CENTER_RIGHT_TEXT_POSITION,
    Luminary.VideoData.BOTTOM_LEFT_TEXT_POSITION,
    Luminary.VideoData.BOTTOM_CENTER_TEXT_POSITION,
    Luminary.VideoData.BOTTOM_RIGHT_TEXT_POSITION,
];

const LUMINARY_RESOLUTION_LOW = 200;
const LUMINARY_RESOLUTION_NORMAL = 320;
const minScreenWidthForNormalResolution = 900; // in px

/**
 * Determines the appropriate resolutionValue Luminary should be created with based
 * on the available width of the user's screen
 */
export function getLuminaryResolutionFromAvailScreenWidth(): number {
    return window.screen && window.screen.availWidth <= minScreenWidthForNormalResolution
        ? LUMINARY_RESOLUTION_LOW
        : LUMINARY_RESOLUTION_NORMAL;
}

export const TEXT_EDITING_OVERFLOW_EVENT = 'nte-text-overflow';
